<ng-container *ngIf="store$ | async as store">
  <mat-divider></mat-divider>
  <br />
  <div
    [style.min-height]="'100px'"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="36px"
  >
    <app-store-image [store]="store"></app-store-image>
    <h2>
      <a [routerLink]="['/store/' + store.id]">{{ store.name }}</a>
    </h2>
  </div>
  <br />
  <mat-divider></mat-divider>
</ng-container>
